import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DialogService } from '../../../core/services/dialog.service';
import { OfferDetailsDialogComponent } from '../../../offers/components/offer-details/offer-details-dialog.component';
import { IOffer } from '../../../offers/models/model';
import { OffersStoreService } from '../../../offers/services/offers-store.service';

@Component({
standalone: false,
  selector: 'app-offer-details-entry',
  styles: [''],
  template: '',
})
export class OfferDetailsDialogEntryComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
    private offersStoreService: OffersStoreService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    const offerId = this.activatedRoute.snapshot.queryParamMap.get('offerId');
    this.offersStoreService
      .getOffer(offerId)
      .pipe(switchMap((offer) => this.openDialog(offer)))
      .subscribe();
  }

  private openDialog(offer: IOffer): Observable<boolean> {
    return this.dialogService
      .open(OfferDetailsDialogComponent, {
        data: offer,
        maxWidth: offer.type === 'ORANGE' ? '100%' : '80%',
      })
      .afterClosed()
      .pipe(switchMap(() => this.router.navigate(['../'], { relativeTo: this.activatedRoute })));
  }
}
